import styled from 'styled-components'

export const LegalDeclarationAgreeAndContinueText = styled.p`
  font-family: ${(props) => props.theme.fontFamily};
  font-weight: 500;
  margin: 1em 0 0.2em 0;
`
export const PolicyDocumentList = styled.ul`
  padding: 0;
  margin: 0;
`
